import { Injectable } from '@angular/core';
import { reduce } from 'lodash';
import { IRowData } from './../../../../shared/models/list-models';

@Injectable()
export class BatchActionsService {
  public initializeStudentBatchActionsHash(): { updateStudentIds: Function; reset: Function } {
    // leverage closure to maintain access to this internal state
    let idHash = {};

    const batchActions = {
      updateStudentIds: ($event: { updateAll: boolean; studentIds: string[] }): void => {
        const { updateAll, studentIds } = $event;
        // mutate hash
        studentIds.forEach((id: string) => {
          const studentId = id.slice(0, -6);
          if (idHash[studentId] && !updateAll) delete idHash[studentId];
          else idHash[studentId] = true;
        });
      },

      getStudentIds: (): string[] => {
        const studentIds = reduce(idHash, (result, _val, key) => (result = [...result, { studentId: key }]), []);
        return studentIds;
      },

      reset: (): void => {
        idHash = {};
      },
    };

    return batchActions;
  }

  public formatBatchActionEvt($event: { updateAll: boolean; data: IRowData[]; level: 'SECTION' | 'ROW' }) {
    let studentIds: string[];
    const { updateAll, data, level } = $event;
    switch (level) {
      case 'SECTION':
        studentIds = data.map((row: IRowData) => this.getStudentIdFromRow(row));
        break;
      case 'ROW':
        studentIds = Array.of(this.getStudentIdFromRow(data));
        break;
      default:
        studentIds = [];
    }
    const batchData = { updateAll, studentIds };
    return batchData;
  }

  public getStudentIdFromRow(row): string {
    const [stub] = row;
    const metaData = JSON.parse(stub.meta);
    const studentId = metaData.data;
    return studentId;
  }
}
